import { Injectable } from '@angular/core';
 import { HttpClient, HttpHeaders } from '@angular/common/http';
 import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DataFetchService {

  constructor(private _http: HttpClient) { }

   reportData(scooterimei,startTs,endTs) {//,startTs,endTs
     return this._http.get<any[]>("https://us-central1-batterypoolapp.cloudfunctions.net/bigquery-fetch-data"+'/?imei='+scooterimei+'&start='+startTs+'&end='+endTs)//+'&start='+startTs+'&end='+endTs
       .pipe(map((result: any) => result));
   }
}
